module.exports = __webpack_public_path__ + "media/images/breadcrumb_devider-6bbd02b284198f724e0479548c28cc99.svg";